import { Component } from "react";

const isChunkError = (e) => /ChunkLoadError|Loading (CSS )?chunk|dynamically imported module/i.test(`${e?.name} ${e?.message}`);

export class ErrorBoundary extends Component {
  state = { error: null };
  static getDerivedStateFromError(error) { return { error }; }
  componentDidCatch(error) {
    console.error(error);
    if (isChunkError(error) && !sessionStorage.getItem("chunk-reload")) { sessionStorage.setItem("chunk-reload", "1"); window.location.reload(); }
  }
  componentDidUpdate(prev) { if (prev.resetKey !== this.props.resetKey && this.state.error) this.setState({ error: null }); }
  render() {
    if (!this.state.error) return this.props.children;
    return (
      <div className="container-x max-w-xl py-24 text-center" data-testid="error-boundary">
        <p className="font-serif text-3xl text-brun">Une erreur est survenue</p>
        <p className="mt-3 text-pierre">Votre panier est conservé. Rechargez la page pour continuer.</p>
        <button onClick={() => { sessionStorage.removeItem("chunk-reload"); window.location.reload(); }} className="btn-primary mt-6" data-testid="error-reload-btn">Recharger la page</button>
      </div>
    );
  }
}
